export default __webpack_public_path__ + "img/eRvkjdVZ.5e052e85.svg";